module.exports = __webpack_public_path__ + "static/media/LOGO-FEMME-TEXTE-NOIR.a5ad040b.png";